import clsx from 'clsx'
import Image from 'next/image'

import Link from '@/atoms/Link/Link'

/* assets */
import { ReactComponent as ArrowRight } from 'public/assets/icons/chevron-right.svg'

/* styles */
import styles from './_.module.css'

interface Props {
  title: string
  image?: StrapiImageFile
  lists: {
    id: string | number
    title: string
    cta: StrapiLinkSharedComponent | null
    image: StrapiImageFile | undefined
    color: string | null
  }[]
}

function MarketingGoals({ title, image, lists }: Props) {
  const buttonColor = [
    'linear-gradient(90deg, #DBC0FF 0%, #C59CFF 99.92%)',
    'linear-gradient(90deg, #BEFFDC 0%, #8FEFBC 99.92%)',
    'linear-gradient(90deg, #C1F6FF -0.02%, #80EDFF 99.9%)'
  ]
  return (
    <section className="text-white">
      <div className="container | py-10 md:py-18">
        <div className="flex items-center justify-between | mb-14">
          <h3
            className="font-heading text-3xl md:text-5xl font-semibold text-blue-web-90"
            dangerouslySetInnerHTML={{ __html: title }}
          />

          {image?.url ? (
            <Image
              src={image.url}
              alt={image.alternativeText ?? ''}
              width={image.width}
              height={image.height}
              className="hidden md:block"
            />
          ) : null}
        </div>
        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {lists.map((item, index) => {
            return (
              <div
                key={item.id}
                className="flex flex-col rounded-2xl overflow-hidden h-[312px] md:h-[365px]"
                style={{ border: `1px solid ${item.color}` }}
              >
                <div
                  className={clsx('p-8 md:px-9 flex-grow', styles.cardBgColor)}
                >
                  {item.image ? (
                    <Image
                      src={item.image.url}
                      height={item.image.height}
                      width={item.image.width}
                      alt={item.image.alternativeText ?? ''}
                      className="mb-8 lg:mb-14"
                    />
                  ) : null}
                  <h3
                    className="font-heading font-medium text-2xl | max-w-col-3 mb-4"
                    dangerouslySetInnerHTML={{ __html: item.title }}
                  />
                </div>
                <div
                  className="py-4 | rounded-bl-xl rounded-br-xl"
                  style={{ background: item.color ?? buttonColor[index] }}
                >
                  <Link
                    href={item.cta?.href}
                    target={item.cta?.target}
                    className="font-body flex justify-center items-center text-blue-web-90 font-medium"
                  >
                    {item.cta?.title}
                    <ArrowRight className="ml-2" />
                  </Link>
                </div>
              </div>
            )
          })}
        </div>
      </div>
    </section>
  )
}

export default MarketingGoals
